import React, { Component } from 'react';
import { Layout, Collapse, Icon, Table, Row, Col, Form, DatePicker, Input, Select, Button, Spin, Modal, Checkbox, Radio, Upload, Cascader, Tabs, Card, List } from 'antd';
import { FormattedMessage, useIntl, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { filter, last, find, includes, remove } from 'lodash';
import { toUpperKey } from '../../../../../util/helpper';
import moment from 'moment';
import './Checklist.css';
import ScrollToTop from '../../../../../components/ScrollToTop';
import MenuSider from '../../../../../components/MenuSider';
import IntlMessages from '../../../../../util/IntlMessages';
import DateTimeFormat from '../../../../../Constants/DateTimeFormat';
import { Odata_Url, Constants } from '../../../../../Constants/Constants';
import Local from '../../../../../Constants/Local';

const { Panel } = Collapse;
const { Content } = Layout;
const { Column } = Table;
const { RangePicker } = DatePicker;
const { Option } = Select;
const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;
const FormItem = Form.Item;
const TabPane = Tabs.TabPane;

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

class Summary extends Component {

    constructor(prop) {
        super(prop);

        this.state = {
            activePanelKeys: [],
            areaDetailText: "",
            attachFilePreviewVisible: false,
            attachFilePreviewUrl: undefined,
        }
    }

    componentDidMount() {

    }

    setSummaryAreaDetail = (areaTrees, siteTrees) => {

        const areaDatas = this.props.areaDatas;

        const areaNames = [];
        areaTrees.forEach(areaId => {
            const areaData = find(areaDatas, (areaData) => {
                return areaData.PKAreaID === areaId;
            });
            if (areaData) {
                areaNames.push(areaData.Name);
            }
        });

        siteTrees.forEach(areaId => {
            const areaData = find(areaDatas, (areaData) => {
                return areaData.PKAreaID === areaId;
            });
            if (areaData) {
                areaNames.push(areaData.Name);
            }
        });

        let areaDetailText = areaNames.join(' / ');
        this.setState({ areaDetailText: areaDetailText });
    }

    setDefaultActivePanelKeys = () => {
        const isUnsafe = this.props.isUnsafe;
        const observationTrn = this.props.observationTrn;

        if (!isUnsafe) {
            this.setState({
                activePanelKeys: [
                    "job_observed",
                    "image",
                    "observation_date_time",
                    "shift",
                    "area",
                    "job_type",
                    "current_safe",
                ]
            });
        }
        else {
            const activePanelKeys = ["job_observed",
                "image",
                "observation_date_time",
                "shift",
                "area",
                "job_type",
                "unsafe_detail",
                "root_cause",
                "next_action_suggestion",
            ];

            if (observationTrn.nearmiss) {
                activePanelKeys.push("near_miss");
            }
            
            this.setState({
                activePanelKeys: activePanelKeys
            });
        }
    }

    onPanelChange = (keys) => {
        this.setState({
            activePanelKeys: keys
        });
    }

    handleAttachFilePreview = async (file) => {
        let url = "";

        if (file.url) {
            url = file.url;
        }
        else {
            url = await getBase64(file.originFileObj);
        }

        this.setState({
            attachFilePreviewUrl: url,
            attachFilePreviewVisible: true,
        });
    };

    handleAttachFileCancel = () => {
        this.setState({
            attachFilePreviewUrl: undefined,
            attachFilePreviewVisible: false
        });
    };

    getTokenHeader = () => {
        var $getToken = new Promise((resolve, reject) => {
            axios.get('auth/token').then((res) => {
                const tokenHeader = { headers: { "Authorization": "Bearer " + res.data } };
                resolve(tokenHeader);
            }).catch(err => {
                if (401 === err.response.status) {
                    localStorage.setItem("ObsReqRedirectAfterLogin", "ObsReqRedirectAfterLogin");
                    window.location.href = "auth";
                }
                reject(err);
            });
        });
        return $getToken;
    }

    render() {
        const local = this.props.intl ? this.props.intl.locale : Local.TH;
        const observationTrn = this.props.observationTrn ? this.props.observationTrn : {};
        const observationTrnAttachments = this.props.observationTrnAttachments ? this.props.observationTrnAttachments : [];

        return (<Card size="small">
            <Row>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Collapse activeKey={this.state.activePanelKeys} onChange={this.onPanelChange}>
                        <Panel header={<IntlMessages id="Action.job_observed" />} key="job_observed">
                            <IntlMessages id="Action.job_observed" />&nbsp;
                            {this.props.isUnsafe ? (<>
                                <Button size="default" type="link" className="subcate-btn-unsafe">Unsafe</Button>
                            </>) : (<>
                                <Button size="default" type="link" className="subcate-btn-safe">Safe</Button>
                            </>)}
                        </Panel>

                        {
                            observationTrn.nearmiss ? (
                                <Panel header={<IntlMessages id="Summary.near_miss" />} key="near_miss">
                                    <Icon type="check-circle" />&nbsp;<IntlMessages id="Summary.near_miss_this" />
                                </Panel>)
                                : null
                        }
                        
                        <Panel header={<IntlMessages id="Summary.image" />} key="image">
                            <div className="clearfix">
                                <Upload
                                    beforeUpload={(file) => {
                                        return false;
                                    }}
                                    listType="picture-card"
                                    showUploadList={{ showPreviewIcon: true, showRemoveIcon: false }}
                                    fileList={observationTrnAttachments}
                                    onPreview={this.handleAttachFilePreview}
                                >
                                </Upload>
                                <Modal visible={this.state.attachFilePreviewVisible} footer={null} onCancel={this.handleAttachFileCancel}>
                                    <img alt="example" style={{ width: '100%' }} src={this.state.attachFilePreviewUrl} />
                                </Modal>
                            </div>
                        </Panel>
                        <Panel header={<IntlMessages id="Summary.observation_date_time" />} key="observation_date_time">
                            {moment(observationTrn.observation_Date, DateTimeFormat.BackendDate).format(DateTimeFormat.Date)}&nbsp;
                            {observationTrn.observation_Time}
                        </Panel>
                        <Panel header={<IntlMessages id="Summary.shift" />} key="shift">
                            {observationTrn.shift}
                        </Panel>
                        <Panel header={<IntlMessages id="Summary.area" />} key="area">
                            <Icon type="environment" />&nbsp;{this.state.areaDetailText ? this.state.areaDetailText : "-"}
                        </Panel>

                        {/*<Panel header={<IntlMessages id="Summary.site" />} key="site">*/}
                        {/*    Summary.site*/}
                        {/*</Panel>*/}

                        <Panel header={<IntlMessages id="Summary.job_type" />} key="job_type">
                            <Button type="default" style={{ height: "64px" }}>
                                <img alt={observationTrn.jobTypeData.Image_name} src={"images/" + observationTrn.jobTypeData.Image_name} style={{ width: "48px" }} />&nbsp;
                            {local === Local.TH ? observationTrn.jobTypeData.Short_detail : observationTrn.jobTypeData.Short_detail_EN}
                            </Button>
                            &nbsp;
                            {observationTrn.jobOtherDetail}
                        </Panel>

                        {this.props.isUnsafe ? (<Panel header={<IntlMessages id="Summary.unsafe_detail" />} key="unsafe_detail">
                            <Table size="small"
                                bordered={true}
                                pagination={false}
                                dataSource={this.props.optCategoryUnSafes}
                                rowKey="PKCategoryID"
                            >
                                <Column dataIndex="Category_Name_EN" title={<IntlMessages id="Action.Category" />} align="left" width="50%"
                                    render={(text, record) => {
                                        if (local === Local.TH) {
                                            return <>{record.Category_Name}</>
                                        }
                                        else {
                                            return <>{record.Category_Name_EN}</>
                                        }
                                    }}
                                />
                                <Column dataIndex="detail" title={<IntlMessages id="Details" />} align="center" />
                            </Table>
                        </Panel>)
                            : null}

                        {this.props.isUnsafe ? (<Panel header={<IntlMessages id="Summary.root_cause" />} key="root_cause">
                            <Table size="small"
                                bordered={true}
                                pagination={false}
                                dataSource={this.props.optCategoryUnSafes}
                                rowKey="PKCategoryID"
                            >
                                <Column dataIndex="Category_Name_EN" title={<IntlMessages id="Action.Category" />} align="left" width="50%"
                                    render={(text, record) => {
                                        if (local === Local.TH) {
                                            return <>{record.Category_Name}</>
                                        }
                                        else {
                                            return <>{record.Category_Name_EN}</>
                                        }
                                    }}
                                />
                                <Column dataIndex="rootcauseID" title={<IntlMessages id="Action.rootcause" />} align="center"
                                    render={(text, record) => {
                                        if (record.rootCauseData) {
                                            if (local === Local.TH) {
                                                return <>{record.rootCauseData.rootcauseTH}</>
                                            }
                                            else {
                                                return <>{record.rootCauseData.rootcauseEN}</>
                                            }
                                        }
                                    }}
                                />
                            </Table>
                        </Panel>) : null}
                        
                        {this.props.isUnsafe ? (<Panel header={<IntlMessages id="Summary.next_action_suggestion" />} key="next_action_suggestion">
                            {observationTrn.unsafe_detail_next_action ? observationTrn.unsafe_detail_next_action : "-"}
                        </Panel>) : null}

                        {(!this.props.isUnsafe) ? (<Panel header={<IntlMessages id="Summary.current_safe" />} key="current_safe">
                            {observationTrn.safe_detail ? observationTrn.safe_detail : "-"}
                        </Panel>) : null}
                    </Collapse>
                </Col>
            </Row>
        </Card>);
    }

}

export default injectIntl(Summary, { withRef: true });